import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";
import { Bell, CaretRight } from "@phosphor-icons/react";

export const NotificationsBell = () => {
  const [open, setOpen] = useState(false);
  const boxRef = useRef(null);
  const navigate = useNavigate();

  const { data } = useQuery({
    queryKey: ["notifications-feed"],
    queryFn: async () => (await api.get("/notifications")).data,
    refetchInterval: 60000,
    refetchOnWindowFocus: true,
  });
  const items = data?.items || [];
  const total = data?.total || 0;

  useEffect(() => {
    const onClick = (e) => { if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  return (
    <div ref={boxRef} className="relative">
      <button
        onClick={() => setOpen((v) => !v)}
        data-testid="notifications-bell"
        aria-label="Notifications"
        className="relative p-2 rounded-full text-muted-foreground hover:text-foreground hover:bg-secondary transition-colors"
      >
        <Bell size={19} />
        {total > 0 && (
          <span className="absolute -top-0.5 -right-0.5 min-w-[17px] h-[17px] px-1 rounded-full bg-primary text-primary-foreground text-[10px] font-bold flex items-center justify-center" data-testid="notifications-badge">
            {total > 99 ? "99+" : total}
          </span>
        )}
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-2 w-80 bg-popover border border-border rounded-lg shadow-2xl z-50 overflow-hidden" data-testid="notifications-panel">
          <div className="px-4 py-3 border-b border-border label-mono">Notifications</div>
          {items.length === 0 ? (
            <div className="px-4 py-8 text-center text-sm text-muted-foreground">All caught up.</div>
          ) : (
            items.map((it) => (
              <button
                key={it.key}
                onClick={() => { setOpen(false); navigate(it.link); }}
                data-testid={`notification-item-${it.key}`}
                className="w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-secondary/60 transition-colors border-b border-border/40 last:border-b-0"
              >
                <span className="min-w-[26px] h-[26px] px-1.5 rounded-full bg-primary/15 text-primary text-xs font-bold flex items-center justify-center">
                  {it.count > 99 ? "99+" : it.count}
                </span>
                <span className="flex-1 text-sm">{it.label}</span>
                <CaretRight size={13} className="text-muted-foreground" />
              </button>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default NotificationsBell;
